<div class="lendio-status-display {{ status?.stage }} {{ (status?.value || '') | camelToKebab }}">
    <div class="lendio-stage-status">
        <div class="status-color-indicator"></div>
        <div class="status-display-text stage">{{ (status?.stage || '') | sentenceCase }}:</div>
        <div class="status-display-text status">{{ (status?.display || '') | sentenceCase }}</div>
    </div>
    <mat-icon *ngIf="showToggle">arrow_drop_down</mat-icon>
</div>
